// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"footer":"d6876bf266189b4dc9a3","mainMenu":"7f07c03898b17f009127"}[chunkId] + ".js";
};